import { isResponseDTO, ResponseDTO } from "../DTO/ServerResponseType/Response";

export let getTypeGuardedVariableAsync = async <T>(
  sendFunctionResult: Promise<unknown>,
  typeGuardFunction: (variable: unknown) => variable is T
): Promise<T | never> => {
  return sendFunctionResult
    .then((response: unknown) => {
      if (!isResponseDTO(response)) {
        console.log("Ответ с сервера не вернулся");
        throw new Error("Ответ с сервера не вернулся");
      }
      return response;
    })
    .then(({ body }: ResponseDTO) => {
      if (!typeGuardFunction(body)) {
        console.log("Неверный тип");
        throw new Error("Неверный тип");
      }
      return body;
    });
};

export let getTypeGuardedArrayVariableAsync = async <T>(
  sendFunctionResult: Promise<unknown>,
  typeGuardFunction: (variable: unknown) => variable is T
): Promise<T[] | never> => {
  return sendFunctionResult
    .then((response: unknown) => {
      if (!isResponseDTO(response)) {
        console.log("Ответ с сервера не вернулся");
        throw new Error("Ответ с сервера не вернулся");
      }
      return response;
    })
    .then(({ body }: ResponseDTO) => {
      if (
        !Array.isArray(body) ||
        !body.reduce(
          (isTypeGuarded, item) => isTypeGuarded && typeGuardFunction(item),
          true
        )
      ) {
        console.log("Неверный тип");
        throw new Error("Неверный тип");
      }

      return body;
    });
};
